export default __webpack_public_path__ + "media/images/features/yado/message_comming_soon-5467f76411c5427f750804809c17d8a7.png";